import { HeaderActions, PageHeader, ReportActions } from "components/Reports/components";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container } from "@mui/material";
import TrialBalanceList from "./TrialBalanceList";
import BasicDateInput from "components/BasicInputs/BasicDateInput";
import useDateState from "helpers/useDateState";
import { ExportContainer, Item, StyledListItemIcon, StyledListItemText } from "../Table/ExportBotton";
import SnippetFolderIcon from "@mui/icons-material/SnippetFolder";

import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { CheckBoxInput } from "components/Input";
import { apiGetTrialBalance } from "../../api/reportApi";
import BasicButton from "components/BasicInputs/BasicButton";
import Moien from "assets/icons/Moien";
import Tafsil from "assets/icons/Tafsil";
import KolMoien from "assets/icons/KolMoein";
import MoienTafsil from "assets/icons/MoienTafsil";
import { setQueryParam, setQueryParams } from "helpers/queryParam";
import { formatPrice } from "helpers";
import { ItemContainer } from "components/Print/StyledComps";
import ReactToPrint from "react-to-print";
import usePrintTrialBlance from "./UsePrintTrialBlance";

const tab = {
    title: "تراز آزمایشی",
    description: "نرم افزار حسابداری",
};

const TrialBalanceComponent = () => {
    const dispatch = useDispatch();
    const { setDates, fromDate, toDate } = useDateState();
    const { token } = useSelector((state: any) => state).businessReducer.business;
    const { trialBalance, trialBalance_sumAmountFinal
    } = useSelector((state: any) => state).reportReducer as {
        trialBalance: reportProfitAndLossDataType
        trialBalance_sumAmountFinal: any[]

    };
    const [CheckBoxValue, setCheckBoxValue] = useState<{ [key: string]: boolean }>({ "2": true })
    const [topFilter, setTopFilter] = useState(-1)
    let trialBalanceData: {}[] = []

    // useEffect(() => {
    //     // @ts-ignore
    //     dispatch(apiGetTrialBalance(token));
    // }, [token]);

    useEffect(() =>
        handleDateFilter()
        , [fromDate, toDate]);


    function addTrialBalanceItem(item: any) {
        trialBalanceData.push(item)
    }

    function exportExcelFile() {
        const worksheet = XLSX.utils.json_to_sheet(trialBalanceData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

        saveAs(blob, 'exported_trial_balance_data.xlsx');
    }

    function handleDateFilter() {
        let params = {};
        if (fromDate && toDate) {
            params = {
                subColumn: "date",
                searchText: fromDate,
                searchTextAlt: toDate,
            };
        }
        // @ts-ignore
        dispatch(apiGetTrialBalance(token, params));
    }
    const onChangeCkeckBox = (e: any, number: number) => {
        setCheckBoxValue({ [number]: e })
        setQueryParams([{ key: "columnNumber", value: number }, { key: "rightLevel", value: topFilter }])
        e && handleDateFilter()

    }
    const columnNumber = Boolean(CheckBoxValue["2"]) ? 2 : Boolean(CheckBoxValue["4"]) ? 4 : Boolean(CheckBoxValue["6"]) ? 6 : 8
    const { content, contentRef } = usePrintTrialBlance({ trialBalance, fromDate, toDate, trialBalance_sumAmountFinal })
    return (

        <Container maxWidth="lg">
            <div className="warp-table">
                <div className="header-table">
                    <PageHeader tab={tab} />
                    <HeaderActions />
                </div>
                <div style={{ display: "flex", gap: 20 }}>
                    <ReportActions />
                    <div style={{ width: 400 }} className={"flex flex-row"}>
                        <BasicDateInput
                            range
                            placeholder="کل سال مالی"
                            onChange={(dates) => setDates(dates)}
                            defaultValues={fromDate && toDate ? [fromDate, toDate] : undefined}

                        />
                        <div className="w-36">
                            <ExportContainer>
                                <Item disableRipple onClick={() => exportExcelFile()}>
                                    <StyledListItemIcon>
                                        <SnippetFolderIcon color="success" />
                                    </StyledListItemIcon>
                                    <StyledListItemText>دانلود اکسل</StyledListItemText>
                                </Item>
                            </ExportContainer>

                        </div>
                        {columnNumber == 4 && topFilter === 2&& < ItemContainer style={{ height: "fit-content", backgroundColor: "white" }}>
                        <div className="hidden">{content}</div>
                        <ReactToPrint
                            trigger={() => (
                                <BasicButton fullWidth variant="outlined">
                                    <span>چاپ گزارش</span>
                                </BasicButton>
                            )}
                            content={() => contentRef.current}
                        />
                    </ItemContainer>}
                </div>
            </div>
            <div className="mt-3 gap-4 flex flex-col " >
                <span>نوع تراز</span>
                <div className="flex gap-32">
                    <CheckBoxInput onChange={(check: boolean) => {
                        onChangeCkeckBox(check, 2)
                    }} className={'[&>label]:text-[#323232] [&>label]:font-medium [&>label]:text-sm [&>input]:rounded-[4px] [&>input]:border [&>input]:border-gray-400 mx-0'} input={{ defaultValue: Boolean(CheckBoxValue["2"]), label: "2 ستونه" }} />
                    <CheckBoxInput onChange={(check: boolean) => {
                        onChangeCkeckBox(check, 4)
                    }} className={'[&>label]:text-[#323232] [&>label]:font-medium [&>label]:text-sm [&>input]:rounded-[4px] [&>input]:border [&>input]:border-gray-400 mx-0'} input={{ defaultValue: Boolean(CheckBoxValue["4"]), label: "4 ستونه" }} />
                    <CheckBoxInput onChange={(check: boolean) => {
                        onChangeCkeckBox(check, 6)
                    }} className={'[&>label]:text-[#323232] [&>label]:font-medium [&>label]:text-sm [&>input]:rounded-[4px] [&>input]:border [&>input]:border-gray-400 mx-0'} input={{ defaultValue: Boolean(CheckBoxValue["6"]), label: "6 ستونه" }} />
                    <CheckBoxInput onChange={(check: boolean) => {
                        onChangeCkeckBox(check, 8)
                    }} className={'[&>label]:text-[#323232] [&>label]:font-medium [&>label]:text-sm [&>input]:rounded-[4px] [&>input]:border [&>input]:border-gray-400 mx-0'} input={{ defaultValue: Boolean(CheckBoxValue["8"]), label: "8 ستونه" }} />
                </div>
            </div>
            <div className="mt-3 gap-4 flex flex-col mb-3 " >
                <span>سطوح حساب</span>
                <div className="flex gap-4">
                    <BasicButton className={`w-[233px] h-10 text-black ${topFilter === 1 ? 'text-white' : 'bg-[#E7EFFA]'} border !border-blue-1 shadow-none rounded-lg`} onClick={() => {
                        setQueryParams([{ key: "columnNumber", value: columnNumber }, { key: "rightLevel", value: 1 }])
                        setTopFilter(1)
                        handleDateFilter()
                    }} variant="contained"   >
                        <Moien stroke={topFilter === 1 ? "#fff" : undefined} />معین
                    </BasicButton>
                    <BasicButton className={`w-[233px] h-10 text-black ${topFilter === 2 ? 'text-white' : 'bg-[#E7EFFA]'} border !border-blue-1 shadow-none rounded-lg`} onClick={() => {
                        setQueryParams([{ key: "columnNumber", value: columnNumber }, { key: "rightLevel", value: 2 }])
                        setTopFilter(2)
                        handleDateFilter()
                    }} variant="contained" ><KolMoien stroke={topFilter === 2 ? "#fff" : undefined} />کل/معین</BasicButton>
                    <BasicButton className={`w-[233px] h-10 text-black ${topFilter === 3 ? 'text-white ' : 'bg-[#E7EFFA] '} border !border-blue-1 shadow-none rounded-lg`} onClick={() => {
                        setQueryParams([{ key: "columnNumber", value: columnNumber }, { key: "rightLevel", value: 3 }])
                        setTopFilter(3)
                        handleDateFilter()
                    }} variant="contained" ><Tafsil stroke={topFilter === 3 ? "#fff" : undefined} />تفصیلی
                    </BasicButton>
                    <BasicButton className={`w-[233px] h-10 text-black ${topFilter === 4 ? 'text-white' : 'bg-[#E7EFFA]'} border !border-blue-1 shadow-none rounded-lg`} onClick={() => {
                        setQueryParams([{ key: "columnNumber", value: columnNumber }, { key: "rightLevel", value: 4 }])
                        setTopFilter(4)
                        handleDateFilter()
                    }} variant="contained" ><MoienTafsil stroke={topFilter === 4 ? "#fff" : undefined} />معین/تفصیل</BasicButton>

                </div >
            </div >
            {trialBalance && <TrialBalanceList columnNumber={Object.keys(CheckBoxValue)[0]} data={trialBalance} addTrialBalanceItem={addTrialBalanceItem} sumAmountFinal={trialBalance_sumAmountFinal} />}
        </div >
        </Container >
    );
};

export default TrialBalanceComponent;
